import React from 'react';
import SETTINGS from '../../settings';
import { connect } from 'react-redux';
import { setSessionVar } from '../../store/actions';

class ImageThumbnail extends React.Component {
  render = () => {
    return (
      <img
        alt={'thumbnail'}
        src={this.props.src}
        onClick={() =>
          this.props.onClick
            ? this.props.onClick(this.props.src)
            : (() => {
                this.props.displayImageViewBox();
                this.props.setImageViewBoxSrc(this.props.largeSrc || this.props.src);
              })()
        }
        height={this.props.height || 55}
        width={this.props.width || 55}
        className={'thumbnail'}
      />
    );
  };
}

const mapStateToProps = (state) => ({
  imageSrc: state.session.vars.imageViewBoxSrc,
  display: state.session.vars.showImageViewBox,
});

const mapDispatchToProps = (dispatch) => ({
  displayImageViewBox: () => dispatch(setSessionVar('showImageViewBox', true)),
  setImageViewBoxSrc: (src) => dispatch(setSessionVar('imageViewBoxSrc', src)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ImageThumbnail);
